import { memo, useContext, useEffect, useState } from "react";
import type { ReactNode } from 'react';
import { Box, Tabs, Tab, Tooltip } from '@mui/material';
import { MtComStyleObj } from '../../styles/MtComStyleObj';
import ArchivedDataHeader from '../common/ArchivedDataHeader';
import { GlobalStateContext } from '../../contexts/GlobalState';

const EQUIPMENTS_TAB = 3;

export type SPLotTabsprops = {
    setActiveTab: (index: number) => void,
    activeTab: number,
    onBackToCurrentView?: () => void,
    rightAction?: ReactNode,
    isArchived?: boolean,
}

function SPLotTab({ activeTab, setActiveTab, onBackToCurrentView, rightAction, isArchived = false }: SPLotTabsprops) {
    const { state } = useContext(GlobalStateContext);
    const [hasTrialsAccess, setHasTrialsAccess] = useState(true);
    const [hasSPLotAccess, setHasSPLotAccess] = useState(true);

    useEffect(() => {
        const roleName = state.roleSelected || state.role?.[0]?.role_name;
        const hasAccess = roleName === "Admin" || roleName === "Technician" || roleName === "S2S-Lead" || roleName === "Breeder";
        setHasTrialsAccess(hasAccess);
        const spLotAccess = roleName === "Breeder" ? false : true;

        if (!hasAccess && activeTab === 2) {
            setActiveTab(1);
        }
        else if (!spLotAccess && activeTab === 1) {
            setActiveTab(2);

        }

        setHasSPLotAccess(spLotAccess)

    }, [state.role, state.roleSelected, setActiveTab]);

    // Equipments is under development, so it must never become the selected tab.
    useEffect(() => {
        if (activeTab === EQUIPMENTS_TAB) setActiveTab(1);
    }, [activeTab, setActiveTab]);

    return (
        <>
            {onBackToCurrentView && (
                <ArchivedDataHeader
                    onBackClick={onBackToCurrentView}
                />
            )}
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1 }}>
                <Box sx={{
                    flex: 1,
                    m: 0,
                    display: 'flex',
                    alignItems: 'stretch',
                    height: 52,
                    background: '#FFFFFF',
                    boxShadow: '0px 3px 5.2px 0px #00000040',
                    border: '1px solid #ECEFF1',
                    borderRadius: '10px',
                    padding: '6px'
                }}>
                    <Box sx={{ flex: 1, m: 0 }}>

                        <Tabs
                            variant="fullWidth"
                            value={activeTab ?? 0}
                            onChange={(_, newValue) => { if (newValue !== EQUIPMENTS_TAB) setActiveTab(newValue); }}

                            sx={(theme) => ({
                                minHeight: 0,
                                height: 1,
                                '& .MuiTabs-flexContainer': { height: '100%', gap: '8px' },
                                '& .MuiTab-root': {
                                    ...MtComStyleObj(theme).tabStyle,
                                    border: 'none',
                                    outline: 'none',
                                    '&:focus': {
                                        outline: 'none',
                                        border: 'none',
                                    },
                                },
                                '& .MuiTab-root:not(:last-child)': {
                                    borderRight: "none"
                                },

                                "& .MuiTabs-indicator": {
                                    display: "none",
                                },

                            })}>
                            {hasSPLotAccess && (
                                <Tab
                                    label="SP Lots"

                                    value={1}
                                    sx={(theme) => ({
                                        color: theme.palette.common.black,
                                        borderRight: activeTab != 2 ? "1px solid black !important" : "none",
                                        '&.Mui-selected': {
                                            ...MtComStyleObj(theme).tabSelected
                                        },


                                    })}
                                />)}
                            <Tab
                                label="Trials"
                                disabled={!hasTrialsAccess}
                                value={2}
                                sx={(theme) => ({
                                    bgcolor: theme.palette.common.white,
                                    color: theme.palette.common.black,
                                    borderRight: activeTab != 3 ? "1px solid black !important" : "none",
                                    '&.Mui-selected': {
                                        ...MtComStyleObj(theme).tabSelected
                                    },

                                })}
                            />
                            {!isArchived && (
                                <Tab
                                    label={
                                        <Tooltip title="Page not ready. Under development." arrow placement="top">
                                            <Box component="span">Equipments</Box>
                                        </Tooltip>
                                    }
                                    value={EQUIPMENTS_TAB}
                                    aria-disabled
                                    sx={(theme) => ({
                                        bgcolor: theme.palette.common.white,
                                        color: theme.palette.text.disabled,
                                        cursor: 'not-allowed',
                                    })}
                                />
                            )}
                        </Tabs>
                    </Box>
                </Box>
                {rightAction}
            </Box>

        </>
    );
}
export default memo(SPLotTab);


















